import React, { ReactNode } from "react";

import "./AdminLicenseCheckModal.scss";

interface AlertModalProps {
  children?: ReactNode;
  onClose: () => void;
  callback: () => void;
  title?: string;
  content?: string;
}

const AdminLicenseCheckModal: React.FC<AlertModalProps> = ({
  children,
  onClose,
  callback,
  title,
  content,
}) => {
  return (
    <div className="alert-modal-overlay">
      <div className="admin-license-check-modal-container ">
        <div className="admin-license-check-modal-header"></div>
        <div className="admin-license-check-modal-content">
          <h2>{title}</h2>
          <p dangerouslySetInnerHTML={{ __html: content || "" }}></p>
        </div>
        <div className="admin-license-check-btn-wrap">
          <div className="admin-license-check-btn-area">
            <button className="cancel"
              style={{ fontSize: "1.8em", border: "none" }}
              onClick={() => {
                onClose();
              }}
            >
              돌아가기
            </button>
            <button className="check"
              style={{ fontSize: "1.8em", border: "none" }}
              onClick={() => {
                onClose();
                callback();
              }}
            >
              관리자 승인
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminLicenseCheckModal;
